import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Button } from './ui/button';
import { Trash2, AlertTriangle } from 'lucide-react';

// Composant de développement pour gérer les comptes de test
const DevTools = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { user, logout } = useAuth();
  
  // N'afficher que si on est en développement
  if (process.env.NODE_ENV !== 'development') {
    return null;
  }

  const clearTestAccounts = () => {
    if (window.confirm('⚠️ Cette action va supprimer tous les comptes de test locaux. Continuer ?')) {
      // Nettoyer le localStorage
      Object.keys(localStorage).forEach(key => {
        if (key.startsWith('firebase_')) {
          localStorage.removeItem(key);
        }
      });
      
      // Se déconnecter si connecté
      if (user) {
        logout();
      }
      
      alert('✅ Comptes de test nettoyés. Vous pouvez maintenant créer de nouveaux comptes.');
    }
  };

  return (
    <div className="fixed bottom-4 right-4 z-50">
      {/* Bouton pour afficher/masquer */}
      <button
        onClick={() => setIsVisible(!isVisible)}
        className="bg-gray-800 hover:bg-gray-700 text-white p-2 rounded-full shadow-lg transition-colors"
        title="Outils de développement"
      >
        <AlertTriangle className="h-4 w-4" />
      </button>

      {/* Panel des outils */}
      {isVisible && (
        <div className="absolute bottom-12 right-0 bg-gray-900/95 backdrop-blur-lg border border-gray-700 rounded-lg p-4 shadow-xl min-w-[280px]">
          <h3 className="text-white font-semibold mb-3 flex items-center space-x-2">
            <AlertTriangle className="h-4 w-4 text-yellow-400" />
            <span>Outils de développement</span>
          </h3>
          
          <div className="space-y-3">
            {user && (
              <div className="p-2 bg-green-600/20 border border-green-600/30 rounded text-green-400 text-sm">
                ✅ Connecté: {user.email}
              </div>
            )}
            
            <div className="space-y-2">
              <p className="text-gray-300 text-sm">
                Utilisez ceci si vous avez des erreurs "email-already-in-use" :
              </p>
              
              <Button
                onClick={clearTestAccounts}
                variant="destructive"
                size="sm"
                className="w-full flex items-center space-x-2"
              >
                <Trash2 className="h-4 w-4" />
                <span>Nettoyer comptes de test</span>
              </Button>
            </div>
            
            <div className="pt-2 border-t border-gray-700">
              <p className="text-gray-500 text-xs">
                ⚠️ Mode développement uniquement
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DevTools;